var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"subjectColumnBox"},[_c('h1',{staticClass:"study-title"},[_c('img',{attrs:{"src":require("../../../assets/img/personalImg/subjectIcon.png"),"alt":""}}),_c('span',[_vm._v("各学科课程学习时长")])]),_c('div',{attrs:{"id":"subjectColumnchart"}})])
}]

export { render, staticRenderFns }